export default __webpack_public_path__ + "static/media/dun.66440904.mp3";